import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFSelect from '../../controls/tempRHFControls/RHFSelect';
import DialogList from 'src/dialogs';
import PayPeriod from 'src/models/AP/PayPeriod';
import InvoiceDocument from '../models/InvoiceDocument';

interface IGenerateTimeSummaryDialogProps {
    dialogName: string;
    handleSubmit?: (payload: InvoiceDocument) => void;
    hideDialog: () => void;
    showDialog: (dialogName: DialogList) => void;
    payPeriods?: Array<PayPeriod>;
}

const GenerateTimeSummaryDialog = (props: IGenerateTimeSummaryDialogProps) => {
    const [payPeriods, setPayPeriods] = useState<Array<PayPeriod>>(undefined);
    const { register, getValues } = useForm();

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!props?.payPeriods) {
            setPayPeriods(props?.payPeriods);
        }
    }, [props?.payPeriods]);

    const onCreate = () => {
        console.log('ReportOptionsDialog onCreate()');
    };

    const OKClicked = () => {
        let data = getValues();
        const payload: Partial<InvoiceDocument> = {
            ...data.generateSummary
        };
        props.handleSubmit(payload);
        props.hideDialog();

        console.log(data);
    };

    return (
        <Dialog title="Generate Timesheet" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                        {payPeriods && <RHFSelect
                            labelStyle={{whiteSpace: 'nowrap'}}
                            labelOnLeft={true}
                            label={'Beginning Pay Period:'}
                            options={!!payPeriods && payPeriods.length > 0 ?
                                payPeriods?.map((pp) => { return {value: pp?.id, label: !!pp?.name ? pp?.name : ''}; }) : []} 
                            name={'generateSummary.begPeriod'}
                            register={register}
                            style={{width: '100%'}}
                            bodyStyle={{width: '50%'}}
                            rules={{ required: 'Pay period required' }}
                        />}
                        {payPeriods && <RHFSelect
                            labelStyle={{whiteSpace: 'nowrap'}}
                            labelOnLeft={true}
                            label={'Ending Pay Period:'}
                            options={!!payPeriods && payPeriods.length > 0 ?
                                payPeriods?.map((pp) => { return {value: pp?.id, label: !!pp?.name ? pp?.name : ''}; }) : []} 
                            name={'generateSummary.endPeriod'}
                            register={register}
                            style={{width: '100%'}}
                            bodyStyle={{width: '50%'}}
                            rules={{ required: 'Pay period required' }}
                        />}
                    </div>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ whiteSpace: 'nowrap', width: '26%', marginRight: '1rem' }}
                    text={'Generate Summary'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default GenerateTimeSummaryDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/GenerateTimeSummaryDialog.tsx